export default __webpack_public_path__ + "static/media/logo_small.8366080c.svg";